export interface RuianFeature {
  attributes?: {
    kod?: number;
    nazev?: string;
  };
}

export interface RuianQueryResponse {
  features?: RuianFeature[];
}

export interface RuianSuggestion {
  code: number;
  name: string;
}

export function buildRuianQueryParams(query: string): Record<string, string> {
  return {
    where: `UPPER(nazev) LIKE UPPER('${escapeRuianLikeValue(query)}%')`,
    outFields: 'kod,nazev',
    returnGeometry: 'false',
    orderByFields: 'nazev',
    resultRecordCount: '8',
    f: 'json'
  };
}

export function mapRuianSuggestions<T extends RuianSuggestion>(features?: RuianFeature[]): T[] {
  const suggestions = features?.flatMap((feature) => {
    const code = feature.attributes?.kod;
    const name = feature.attributes?.nazev?.trim();

    if (typeof code !== 'number' || !name) {
      return [];
    }

    return [{ code, name } as T];
  }) ?? [];

  return suggestions.filter((suggestion, index, allSuggestions) =>
    allSuggestions.findIndex((item) => item.code === suggestion.code) === index
  );
}

function escapeRuianLikeValue(value: string): string {
  return value.replace(/'/g, "''");
}
